import * as React from 'react';
import { styled } from '@linaria/react';

import useBoundingBox from '@/hooks/use-bounding-box';
import { clamp, normalize } from '@/utils';

interface Coord {
  value: string;
  label: string;
}

interface Props {
  values: [Coord, Coord];
  minWidth?: string;
}

function CoordDisplay({ values, minWidth = '5rem' }: Props) {
  return (
    <Wrapper style={{ '--min-width': minWidth }}>
      {values.map(({ value, label }) => (
        <Col key={label}>
          <Label>{label}</Label>
          <Value>{value}</Value>
        </Col>
      ))}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: var(--min-width);
  font-family: var(--font-family-mono);
`;

const Label = styled.div`
  font-size: 0.75rem;
  color: var(--main-color);
  font-weight: var(--font-weight-bold);
`;

const Value = styled.div`
  font-size: 1.5rem;
  color: var(--color-text);
  font-weight: var(--font-weight-bold);
`;

export default CoordDisplay;
